import { Tooltip } from '@genial/components';
import { Stack } from 'native-base';
import React, { useMemo } from 'react';

import { CustomerDetailFullAccount } from '../../../../../../../../store/customerDetail/types';
import { getWithdrawalEligibility } from '../../../../../../../../store/customerDetail/withdrawal/constants';

export namespace WithdrawalEligibilityTooltipTypes {
  export type Props = {
    children: React.ReactElement;
    customer?: CustomerDetailFullAccount | null;
    isLoading?: boolean;
    hasError?: boolean;
    tooltipMessage?: string;
  };
}

export const WithdrawalEligibilityTooltip: React.FC<WithdrawalEligibilityTooltipTypes.Props> = ({
  children,
  customer,
  isLoading,
  hasError,
  tooltipMessage: tooltipMessageProp,
}) => {
  const tooltipMessage = useMemo(() => {
    if (tooltipMessageProp !== undefined) {
      return tooltipMessageProp;
    }

    return getWithdrawalEligibility(customer, !!isLoading, !!hasError).tooltipMessage;
  }, [customer, hasError, isLoading, tooltipMessageProp]);

  if (!tooltipMessage) {
    return children;
  }

  return (
    <Tooltip label={tooltipMessage}>
      <Stack>{children}</Stack>
    </Tooltip>
  );
};
